// Postal code prefix -> region. FR: the department (2 digits, 3 overseas). IT: the 2-digit CAP prefix, which
// identifies a province area and never straddles two regions.
const regionsByPostalCodePrefix: Record<string, Record<string, string[]>> = {
  FR: {
    'Auvergne-Rhône-Alpes': ['01', '03', '07', '15', '26', '38', '42', '43', '63', '69', '73', '74'],
    'Bourgogne-Franche-Comté': ['21', '25', '39', '58', '70', '71', '89', '90'],
    Bretagne: ['22', '29', '35', '56'],
    'Centre-Val de Loire': ['18', '28', '36', '37', '41', '45'],
    Corse: ['20'],
    'Grand Est': ['08', '10', '51', '52', '54', '55', '57', '67', '68', '88'],
    'Hauts-de-France': ['02', '59', '60', '62', '80'],
    'Île-de-France': ['75', '77', '78', '91', '92', '93', '94', '95'],
    Normandie: ['14', '27', '50', '61', '76'],
    'Nouvelle-Aquitaine': ['16', '17', '19', '23', '24', '33', '40', '47', '64', '79', '86', '87'],
    Occitanie: ['09', '11', '12', '30', '31', '32', '34', '46', '48', '65', '66', '81', '82'],
    'Pays de la Loire': ['44', '49', '53', '72', '85'],
    "Provence-Alpes-Côte d'Azur": ['04', '05', '06', '13', '83', '84'],
    Guadeloupe: ['971'],
    Martinique: ['972'],
    Guyane: ['973'],
    'La Réunion': ['974'],
    Mayotte: ['976'],
  },
  IT: {
    Lazio: ['00', '01', '02', '03', '04'],
    Umbria: ['05', '06'],
    Sardegna: ['07', '08', '09'],
    Piemonte: ['10', '12', '13', '14', '15', '28'],
    "Valle d'Aosta": ['11'],
    Liguria: ['16', '17', '18', '19'],
    Lombardia: ['20', '21', '22', '23', '24', '25', '26', '27', '46'],
    'Emilia-Romagna': ['29', '40', '41', '42', '43', '44', '47', '48'],
    Veneto: ['30', '31', '32', '35', '36', '37', '45'],
    'Friuli-Venezia Giulia': ['33', '34'],
    'Trentino-Alto Adige': ['38', '39'],
    Toscana: ['50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
    Marche: ['60', '61', '62', '63'],
    Abruzzo: ['64', '65', '66', '67'],
    Puglia: ['70', '71', '72', '73', '74', '76'],
    Basilicata: ['75', '85'],
    Campania: ['80', '81', '82', '83', '84'],
    Molise: ['86'],
    Calabria: ['87', '88', '89'],
    Sicilia: ['90', '91', '92', '93', '94', '95', '96', '97', '98'],
  },
};

const regionByPrefix = Object.fromEntries(
  Object.entries(regionsByPostalCodePrefix).map(([country, regions]) => [
    country,
    new Map(Object.entries(regions).flatMap(([region, prefixes]) => prefixes.map(prefix => [prefix, region]))),
  ]),
);

export const getRegionFromPostalCode = (country: string, postalCode?: string): string | undefined => {
  const regions = regionByPrefix[country];

  if (!regions || !postalCode) {
    return undefined;
  }

  return regions.get(postalCode.slice(0, 3)) ?? regions.get(postalCode.slice(0, 2));
};
